<div class="modal-body">
  <div>
    <div class="text-center m-b-30">
      <fa-icon icon="calendar" class="c-link-blue t-50"></fa-icon>
      <br />
      <br />
      <h1 id="modal-title" class="brandfont-black modal-title">{{ "newdash.choose_date" | translate }}</h1>
    </div>
    <div class="d-flex justify-content-center">
      <div style="width: 200px" class="m-x-10" aria-label="Month">
        <myp-autocomplete-dropdown idName="month" (selected)="select($event, 'month')" [hasDefault]="true" [items]="months" hint="Month..." [selection]="selectedMonth"></myp-autocomplete-dropdown>
      </div>
      <div style="width: 100px" class="m-x-10" aria-label="Day">
        <myp-autocomplete-dropdown idName="day" (selected)="select($event, 'day')" [hasDefault]="true" [items]="days" hint="Day..." [selection]="selectedDay"></myp-autocomplete-dropdown>
      </div>
      <div style="width: 200px" class="m-x-10" aria-label="Year">
        <myp-autocomplete-dropdown idName="year" (selected)="select($event, 'year')" [hasDefault]="true" [items]="years" hint="Year..." [selection]="selectedYear"></myp-autocomplete-dropdown>
      </div>
    </div>
    @if (includeTimePicker) {
      <div class="d-flex justify-content-center m-t-20">
        <div class="d-flex align-items-center m-x-10">
          <select class="form-control custom-select-sm m-x-5" style="width: 100px" (ngModelChange)="setDate()" [(ngModel)]="selectedHour">
            @for (hour of hours; track hour) {
              <option [value]="hour">{{ hour }}</option>
            }
          </select>
          :
          <select class="form-control custom-select-sm m-x-5" style="width: 100px" (ngModelChange)="setDate()" [(ngModel)]="selectedMinute">
            @for (minute of minutes; track minute) {
              <option [value]="minute">{{ minute }}</option>
            }
          </select>
          <select class="form-control custom-select-sm m-x-5" style="width: 100px" (ngModelChange)="setDate()" [(ngModel)]="selectedAmPm">
            <option value="am">am</option>
            <option value="pm">pm</option>
          </select>
        </div>
      </div>
    }
    @if (includeTimeZonePicker) {
      <div class="d-flex justify-content-center m-t-15">
        <select class="form-control" style="width: 320px" [(ngModel)]="selectedTimezone" (ngModelChange)="setDate()">
          @for (tz of timezoneOptions; track tz.value) {
            <option [value]="tz.value">{{ tz.label }}</option>
          }
        </select>
      </div>
    }
  </div>
  <div class="text-center m-t-50">
    <span class="brandfont-black">{{ prettySelectedDate }}</span>
    <br />
    <fa-icon icon="chevron-down" aria-hidden="true"></fa-icon>
    <br />
    <button ngbAutofocus class="btn btn-primary" (click)="done()">Select Date</button>
    <br />
    <br />
    <button class="link" (click)="close($event)">Cancel</button>
  </div>
</div>
